"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchCorrType = exports.PunchCorrReason = exports.PunchCorrStatus = exports.ViewPunchCorrectionStatusUrlParam = void 0;
exports.ViewPunchCorrectionStatusUrlParam = 'viewPunchCorrectionStatus';
var PunchCorrStatus;
(function (PunchCorrStatus) {
    PunchCorrStatus["PENDING"] = "PENDING";
    PunchCorrStatus["IN_PROGRESS"] = "IN_PROGRESS";
    PunchCorrStatus["SUBMITTED_SUCCESSFULLY"] = "SUBMITTED_SUCCESSFULLY";
    PunchCorrStatus["COMPLETED_SUCCESSFULLY"] = "COMPLETED_SUCCESSFULLY";
    PunchCorrStatus["FAILED_PENDING_RETRY"] = "FAILED_PENDING_RETRY";
    PunchCorrStatus["FAILED"] = "FAILED";
    PunchCorrStatus["CLOSED"] = "CLOSED";
})(PunchCorrStatus = exports.PunchCorrStatus || (exports.PunchCorrStatus = {}));
var PunchCorrReason;
(function (PunchCorrReason) {
    PunchCorrReason["DUPLICATE"] = "DUPLICATE";
    PunchCorrReason["PENDING_REVIEW"] = "PENDING_REVIEW";
    PunchCorrReason["REJECTED"] = "REJECTED";
    PunchCorrReason["DEPENDENCY_FAILURE"] = "DEPENDENCY_FAILURE";
})(PunchCorrReason = exports.PunchCorrReason || (exports.PunchCorrReason = {}));
var PunchCorrType;
(function (PunchCorrType) {
    PunchCorrType["DELETE_PUNCH"] = "DELETE_PUNCH_REQUEST";
    PunchCorrType["MISSED_PUNCH"] = "SUBMIT_MISSED_PUNCH_REQUEST";
    PunchCorrType["EDIT_PUNCH"] = "EDIT_PUNCH_REQUEST";
    PunchCorrType["A_TO_Z_CLOCK_PUNCH"] = "SUBMIT_CLOCK_PUNCH_REQUEST";
})(PunchCorrType = exports.PunchCorrType || (exports.PunchCorrType = {}));
